import { LabCustomerUserPrivate as _LabCustomerUserPrivate } from '@team-milva/lab-models/user'
import type { ILabCustomerUserPrivate } from '@team-milva/lab-models/user'
import type { ITermsOfUseAcceptance } from './LabCustomerUserBusiness'

// App-local field until MIL-136 (Terms of Use, authored/versioned in lab-management) ships —
// then this should move into ILabCustomerUserPrivate in @team-milva/lab-models.
export class LabCustomerUserPrivate extends _LabCustomerUserPrivate {
  termsAccepted: ITermsOfUseAcceptance | null

  constructor(
    params: Partial<ILabCustomerUserPrivate> & {
      termsAccepted?: ITermsOfUseAcceptance | null
    } = {}
  ) {
    super(params)
    this.termsAccepted = params.termsAccepted ?? null
  }
}
